import SectionTitle from "./SectionTitle";

const depositMethods = [
  { icon: "ri-smartphone-line", title: "PayID & Osko (Instant AUD)", body: "Australia's fastest payment method. Deposit instantly using your PayID (phone number or email). Minimum deposit AUD 8. Funds credited in seconds." },
  { icon: "ri-bank-card-line", title: "Visa & Mastercard", body: "Deposit securely using your Australian Visa or Mastercard. Instant processing with no extra fees. Widely accepted and trusted by Australian players." },
  { icon: "ri-wallet-3-line", title: "Google Pay & Apple Pay", body: "One-tap funding directly from your mobile device. Fast, secure, and convenient for Australian players on the go." },
  { icon: "ri-secure-payment-line", title: "Amopay & Speedpay", body: "Additional e-wallet options for fast and secure deposits. Amopay and Speedpay offer seamless AUD transactions with instant crediting." },
  { icon: "ri-bit-coin-line", title: "Cryptocurrency (BTC, ETH, USDT)", body: "Supports Bitcoin, Ethereum, and USDT for fast, anonymous, and secure deposits. Ideal for players who prefer crypto transactions." },
];

const withdrawalMethods = [
  { icon: "ri-smartphone-line", title: "PayID Withdrawal", body: "Withdraw directly to your Australian bank account via PayID. Minimum withdrawal AUD 28. Fast processing with funds typically arriving within hours." },
  { icon: "ri-bank-line", title: "Bank Transfer", body: "Standard bank transfer to any Australian bank account. Minimum withdrawal AUD 28. Reliable and secure with multi-step review procedures to reduce fraud risk." },
  { icon: "ri-bit-coin-line", title: "Cryptocurrency Withdrawals", body: "Withdraw in BTC, ETH, or USDT. Fast processing within 24 hours. Secure and private with no intermediary banks involved." },
];

export default function Payment() {
  return (
    <section id="payment" className="py-12">
      <SectionTitle>Payment Variants</SectionTitle>

      <p className="text-slate-300 leading-relaxed mb-8 text-sm">
        Ace96au supports multiple fast and secure payment options tailored for Australian players. With a minimum deposit of just AUD 8 and minimum withdrawal of AUD 28, getting started and cashing out has never been easier. Supported methods include PayID, Osko, Google Pay, Apple Pay, Amopay, Speedpay, Visa, Mastercard, Bitcoin, ETH, and USDT. All transactions are protected with 256-bit SSL encryption.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3
            className="text-sm font-bold mb-4 flex items-center gap-2 tracking-widest uppercase"
            style={{ color: "#4ade80" }}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-circle-fill text-green-400"></i>
            </span>
            Deposit Methods
          </h3>
          <div className="space-y-3">
            {depositMethods.map((m, i) => (
              <div key={i} className="glass-card rounded-xl p-4 flex items-start gap-3">
                <div
                  className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0"
                  style={{ background: "rgba(74,222,128,0.1)", border: "1px solid rgba(74,222,128,0.2)" }}
                >
                  <i className={`${m.icon} text-green-400`}></i>
                </div>
                <div>
                  <strong className="text-slate-200 text-xs font-semibold block mb-1">{m.title}</strong>
                  <p className="text-slate-400 text-xs">{m.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3
            className="text-sm font-bold mb-4 flex items-center gap-2 tracking-widest uppercase"
            style={{ color: "#e0c97f" }}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-up-circle-fill" style={{ color: "#e0c97f" }}></i>
            </span>
            Withdrawal Methods
          </h3>
          <div className="space-y-3">
            {withdrawalMethods.map((m, i) => (
              <div key={i} className="glass-card rounded-xl p-4 flex items-start gap-3">
                <div
                  className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0"
                  style={{ background: "rgba(224,201,127,0.1)", border: "1px solid rgba(224,201,127,0.2)" }}
                >
                  <i className={`${m.icon}`} style={{ color: "#e0c97f" }}></i>
                </div>
                <div>
                  <strong className="text-slate-200 text-xs font-semibold block mb-1">{m.title}</strong>
                  <p className="text-slate-400 text-xs">{m.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
